import { useCallback } from "react";
import {
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuCheckboxItem,
  DropdownMenuItem,
  DropdownMenuIcon,
} from "@/components/ui/dropdown-menu";
import { SingleFilterMenuItemType } from "../FilterMenu.model";
import { isNullFilter } from "../FieldFilter.model";

interface SingleFilterMenuItemProps<Field extends string>
  extends SingleFilterMenuItemType<Field> {
  onChange: (item: SingleFilterMenuItemType<Field>) => void;
}

export function SingleFilterMenuItem<Field extends string>({
  onChange,
  ...item
}: SingleFilterMenuItemProps<Field>) {
  const handleOptionClick = useCallback(
    (option: string) => {
      if (item.value == null || isNullFilter(item.value)) {
        onChange({
          ...item,
          value: {
            operator: "eq",
            value: option,
          },
        });
        return;
      }

      onChange({
        ...item,
        value: {
          operator: item.value?.operator ?? "eq",
          value: option,
        },
      });
    },
    [item, onChange]
  );

  if (item.value?.value == null) {
    return (
      <DropdownMenuSub>
        <DropdownMenuSubTrigger>
          {item.icon && <DropdownMenuIcon>{item.icon}</DropdownMenuIcon>}
          {item.label}
        </DropdownMenuSubTrigger>
        <DropdownMenuSubContent sideOffset={8} alignOffset={-5}>
          {item.options.map(({ label, value, icon }) => (
            <DropdownMenuItem
              key={value}
              onClick={() => handleOptionClick(value)}
            >
              {icon && <DropdownMenuIcon>{icon}</DropdownMenuIcon>}
              {label}
            </DropdownMenuItem>
          ))}
        </DropdownMenuSubContent>
      </DropdownMenuSub>
    );
  }

  return (
    <DropdownMenuSub>
      <DropdownMenuSubTrigger>
        {item.icon && <DropdownMenuIcon>{item.icon}</DropdownMenuIcon>}
        {item.label}
      </DropdownMenuSubTrigger>
      <DropdownMenuSubContent sideOffset={8} alignOffset={-5}>
        {item.options.map(({ label, value, icon }) => (
          <DropdownMenuCheckboxItem
            key={value}
            checked={item.value?.value === value}
            onCheckedChange={() => handleOptionClick(value)}
          >
            {icon && <DropdownMenuIcon>{icon}</DropdownMenuIcon>}
            {label}
          </DropdownMenuCheckboxItem>
        ))}
      </DropdownMenuSubContent>
    </DropdownMenuSub>
  );
}
